import React from "react";
import { Row, Col, Card, Statistic, Tooltip, Icon } from "antd";
import PropTypes from "prop-types";
import { countryFlags, countryNames, productConfig } from "./utils/constants";
import { CreditSymbol } from "./utils/formatters";

/**
 * WalletSummaryCards - Summary statistics cards for selected wallet type/country
 */
const WalletSummaryCards = ({ tableData, selectedType, selectedCountry }) => {
  if (!selectedType || !selectedCountry) return null;

  const totalAvailable = tableData.reduce(
    (sum, w) => sum + (w.credit_available || 0),
    0
  );
  const totalPurchased = tableData.reduce(
    (sum, w) => sum + (w.credit_purchased || 0),
    0
  );
  const usedCredit = totalPurchased - totalAvailable;
  const usagePercent =
    totalPurchased > 0 ? ((usedCredit / totalPurchased) * 100).toFixed(1) : 0;

  // Calculate dollar value for SMS
  const totalDollarAvailable = tableData.reduce(
    (sum, w) => sum + (w.unit_price || 0) * (w.credit_available || 0),
    0
  );
  const totalDollarPurchased = tableData.reduce(
    (sum, w) => sum + (w.unit_price || 0) * (w.credit_purchased || 0),
    0
  );

  const config = productConfig[selectedType] || productConfig.sms;
  const isSms = selectedType === "sms";

  const availablePrefix = isSms ? <CreditSymbol /> : "$";
  const purchasedPrefix = isSms ? <CreditSymbol /> : "$";

  const renderAvailableCard = () => (
    <Card className="wallet-stat-card wallet-stat-available">
      <Statistic
        title="Credit Available"
        value={totalAvailable}
        precision={2}
        prefix={availablePrefix}
        valueStyle={{ color: "#52c41a" }}
      />
    </Card>
  );

  const renderPurchasedCard = () => (
    <Card className="wallet-stat-card wallet-stat-purchased">
      <Statistic
        title="Credit Purchased"
        value={totalPurchased}
        precision={2}
        prefix={purchasedPrefix}
        valueStyle={{ color: "#1890ff" }}
      />
    </Card>
  );

  return (
    <div className="wallet-summary-section">
      <div className="wallet-summary-header">
        <span className="wallet-summary-icon" style={{ color: config.color }}>
          <Icon type={config.icon} />
        </span>
        <span className="wallet-summary-title">
          {selectedType.toUpperCase()} -{" "}
          {countryNames[selectedCountry] || selectedCountry}
        </span>
        <span className="wallet-summary-flag">
          {countryFlags[selectedCountry] || "🌍"}
        </span>
      </div>
      <Row gutter={16} className="wallet-summary-cards">
        <Col span={8}>
          {isSms ? (
            <Tooltip title={`≈ $${totalDollarAvailable.toFixed(4)} USD`}>
              {renderAvailableCard()}
            </Tooltip>
          ) : (
            renderAvailableCard()
          )}
        </Col>
        <Col span={8}>
          {isSms ? (
            <Tooltip title={`≈ $${totalDollarPurchased.toFixed(4)} USD`}>
              {renderPurchasedCard()}
            </Tooltip>
          ) : (
            renderPurchasedCard()
          )}
        </Col>
        <Col span={8}>
          <Card className="wallet-stat-card wallet-stat-usage">
            <Statistic
              title="Usage"
              value={usagePercent}
              precision={1}
              suffix="%"
              valueStyle={{ color: "#faad14" }}
            />
          </Card>
        </Col>
      </Row>
    </div>
  );
};

WalletSummaryCards.propTypes = {
  tableData: PropTypes.array,
  selectedType: PropTypes.string,
  selectedCountry: PropTypes.string,
};

WalletSummaryCards.defaultProps = {
  tableData: [],
  selectedType: null,
  selectedCountry: null,
};

export default WalletSummaryCards;



// WEBPACK FOOTER //
// ./src/containers/User/UserManagement/components/MemberCreditWallet/WalletSummaryCards.js